// WebSocket 连接管理器
const WebSocketManager = {
    // 存储所有活跃的 WebSocket 连接
    connections: {},
    // 获取现有连接
    getExistingConnection(url) {
        try {
            const connection = this.connections[url];
            if (connection && connection.readyState === WebSocket.OPEN) {
                console.log('获取现有WebSocket连接:', url);
                return connection;
            }
            return null;
        } catch (error) {
            console.error('获取现有连接失败:', error);
            return null;
        }
    },
    // 获取连接（如果不存在则创建）
    getConnection(url, options = {}) {
        // 如果已存在相同 URL 的连接，直接返回
        const existingConnection = this.getExistingConnection(url);
        if (existingConnection) {
            return Promise.resolve(existingConnection);
        }

        // 检查连接数量限制
        return this.checkSocketLimit().then(() => {
            // 创建新连接
            console.log('创建新的 WebSocket 连接:', url);
            const socketTask = new WebSocket(url);

            // 设置事件处理
            socketTask.onopen = () => {
                console.log('WebSocket 连接已打开:', url);
                if (options.onOpen) options.onOpen();
            };

            socketTask.onclose = (res) => {
                console.log('WebSocket 连接已关闭:', url, res);
                // 从连接列表中移除
                delete this.connections[url];
                if (options.onClose) options.onClose(res);
            };

            socketTask.onerror = (err) => {
                console.error('WebSocket 连接错误:', url, err);
                if (options.onError) options.onError(err);
            };

            socketTask.onmessage = (res) => {
                if (options.onMessage) options.onMessage(res);
            };

            // 存储连接
            this.connections[url] = socketTask;
            return socketTask;
        });
    },

    // 关闭指定连接
    closeConnection(url) {
        if (this.connections[url]) {
            try {
                this.connections[url].close();
                console.log('WebSocket 连接已关闭:', url);
                delete this.connections[url];
            } catch (err) {
                console.error('关闭 WebSocket 连接失败:', url, err);
            }
        }
    },

    // 关闭所有连接
    closeAllConnections() {
        Object.keys(this.connections).forEach(url => {
            this.closeConnection(url);
        });
    },

    // 检查连接数量限制
    checkSocketLimit() {
        return new Promise((resolve) => {
            // 获取当前连接数量
            const connectionCount = Object.keys(this.connections).length;
            console.log('当前 WebSocket 连接数量:', connectionCount);

            // 如果连接数量已达到上限，关闭最早的连接
            if (connectionCount >= 5) {
                console.log('WebSocket 连接数量已达上限，关闭最早的连接');
                // 获取最早的连接
                const oldestUrl = Object.keys(this.connections)[0];
                // 关闭最早的连接
                this.closeConnection(oldestUrl);
            }

            resolve();
        });
    }
};

export default WebSocketManager;